import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-left" }, "Excluir Escala?", -1)
const _hoisted_2 = { class: "flex flex-col gap-4 text-left" }
const _hoisted_3 = { class: "text-base font-normal" }
const _hoisted_4 = { class: "font-bold" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "text-sm text-gray-500",
  "data-testid": "remove-schedule-preview-loading"
}
const _hoisted_7 = {
  key: 1,
  class: "flex flex-col gap-1 rounded border border-gray-200 bg-gray-50 p-3 text-sm",
  "data-testid": "remove-schedule-preview"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "font-bold" }
const _hoisted_10 = { class: "list-disc pl-5" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-600" }, "Os plantões passados ficam guardados como histórico.", -1)
const _hoisted_15 = {
  key: 2,
  class: "rounded border border-red-300 bg-red-50 p-3 text-sm text-red-700",
  "data-testid": "remove-schedule-blocked"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "text-base font-normal" }, "É necessário digitar o nome da escala para excluí-la", -1)
const _hoisted_17 = { class: "flex gap-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_filled_button = _resolveComponent("filled-button")!
  const _component_outline_button = _resolveComponent("outline-button")!
  const _component_modal_vue = _resolveComponent("modal-vue")!

  return (_openBlock(), _createBlock(_component_modal_vue, {
    onClose: $setup.handleToggleModal,
    modalActive: $setup.modals[$setup.modalName],
    maxWidth: "max-w-[525px]",
    hasHeaderBorder: true
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_filled_button, {
          class: "flex-1",
          onClick: $setup.handleToggleModal,
          text: "Cancelar"
        }, null, 8, ["onClick"]),
        _createVNode(_component_outline_button, {
          class: "flex-1 !text-red-600 !border-red-600 hover:!bg-red-50 hover:!text-red-700",
          disabled: !$setup.isConfirmed || $setup.isLoading || $setup.isLoadingPreview || $setup.isBlocked,
          loading: $setup.isLoading,
          text: "Confirmar",
          onClick: $setup.handleRemove
        }, null, 8, ["disabled", "loading", "onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, [
          _createTextVNode(" Tem certeza que deseja excluir a escala \""),
          _createElementVNode("span", _hoisted_4, _toDisplayString($props.scheduleName), 1),
          _createTextVNode("\"?"),
          _hoisted_5,
          _createTextVNode(" Essa ação não poderá ser desfeita! ")
        ]),
        ($setup.isLoadingPreview)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, " Verificando os plantões futuros da escala... "))
          : ($setup.preview)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                ($setup.preview.futureStations === 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, "Esta escala não tem plantões futuros."))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("p", null, [
                        _createTextVNode(" Esta escala tem "),
                        _createElementVNode("span", _hoisted_9, _toDisplayString($setup.futureStationsText), 1),
                        _createTextVNode(": ")
                      ]),
                      _createElementVNode("ul", _hoisted_10, [
                        ($setup.preview.futureVacant > 0)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_11, _toDisplayString($setup.futureVacantText), 1))
                          : _createCommentVNode("", true),
                        ($setup.preview.futureWithDoctor > 0)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_12, _toDisplayString($setup.futureWithDoctorText), 1))
                          : _createCommentVNode("", true),
                        ($setup.preview.futureUnidentified > 0)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_13, _toDisplayString($setup.futureUnidentifiedText), 1))
                          : _createCommentVNode("", true)
                      ])
                    ], 64)),
                _hoisted_14
              ]))
            : _createCommentVNode("", true),
        ($setup.blockedMessage)
          ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString($setup.blockedMessage), 1))
          : _createCommentVNode("", true),
        _hoisted_16,
        _createVNode(_component_v_text_field, {
          modelValue: $setup.confirmationText,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.confirmationText) = $event)),
          placeholder: $props.scheduleName,
          variant: "outlined",
          density: "compact",
          "hide-details": "",
          "data-testid": "remove-schedule-confirmation-input"
        }, null, 8, ["modelValue", "placeholder"])
      ])
    ]),
    _: 1
  }, 8, ["onClose", "modalActive"]))
}